const JAKARTA_TIMEZONE = "Asia/Jakarta";

function getJakartaDateParts(dateValue = new Date()) {
  const parts = new Intl.DateTimeFormat("en-CA", {
    timeZone: JAKARTA_TIMEZONE,
    year: "numeric",
    month: "2-digit",
    day: "2-digit"
  }).formatToParts(new Date(dateValue));

  const partValue = (type) =>
    parts.find((part) => part.type === type)?.value || "";

  return {
    year: partValue("year"),
    month: partValue("month"),
    day: partValue("day")
  };
}

export function getTodayISOInJakarta() {
  const { year, month, day } = getJakartaDateParts();
  return `${year}-${month}-${day}`;
}

export function getTodayPartsInJakarta() {
  const { year, month, day } = getJakartaDateParts();
  const monthIndex = Number(month) - 1;
  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  return {
    year,
    month: monthNames[monthIndex] || "",
    day: String(Number(day))
  };
}

export function getISODateParts(dateStr) {
  const match = String(dateStr || "").match(/^(\d{4})-(\d{2})-(\d{2})$/);
  if (!match) {
    return { year: "", month: "", day: "", monthName: "" };
  }

  const monthNames = [
    "January",
    "February",
    "March",
    "April",
    "May",
    "June",
    "July",
    "August",
    "September",
    "October",
    "November",
    "December"
  ];

  const monthNumber = Number(match[2]);

  return {
    year: match[1],
    month: match[2],
    day: String(Number(match[3])),
    monthName: monthNames[monthNumber - 1] || ""
  };
}
